import { render, staticRenderFns } from "./Articleclass.vue?vue&type=template&id=5487ebec&scoped=true&"
import script from "./Articleclass.vue?vue&type=script&lang=js&"
export * from "./Articleclass.vue?vue&type=script&lang=js&"
import style0 from "./Articleclass.vue?vue&type=style&index=0&id=5487ebec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487ebec",
  null
  
)

export default component.exports